<!-- Even goed testen of dit overal werkt -->
<div class="product-header" [class.product-header--no-min-height]="hasNoMinHeight">
    <div class="wrapper">
        <div class="col-4 product-header__image" [ngClass]="{ 'text-center': imgCentered }">
            <ng-content select=".product-header-image"></ng-content>
        </div>
        <div class="col-5" [ngClass]="{ 'col-5': hasAggregateContent, 'col-8': !hasAggregateContent }">
            <ng-content select=".product-header-content"></ng-content>
        </div>
        <div class="col-3" [ngClass]="{ 'col-3': hasAggregateContent, 'col-0': !hasAggregateContent }">
            <div class="product-header__aggregate" #aggregate>
                <ng-content select=".product-header-aggregate"></ng-content>
            </div>
        </div>
    </div>
</div>
